import { useLocalSearchParams } from "expo-router";
import { TeamMemberForm } from "~/components/form/team/TeamMemberForm";
import { Authorize } from "~/components/permission/Authorize";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useProfile } from "~/providers/ProfileProvider";

export default function EditTeam() {
    const { team_member_id }: { team_member_id: string } = useLocalSearchParams();
    const { findTeam, canUpdateTeamMember } = useProfile();
    const { handleDismiss } = useDismiss();

    const member = findTeam(team_member_id);

    if (!member || !canUpdateTeamMember(team_member_id)) {
        return <Dismiss />;
    }

    return (
        <Authorize ability="update" section="team">
            <TeamMemberForm onRequestClose={handleDismiss} member={member} asRoute />
        </Authorize>
    );
}
